import { Component } from '@angular/core';
import { AuthService } from '@app/infra/auth/auth.service';
import { NavService } from '@app/infra/nav/nav.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  isShrinked = true;

  constructor(public authService: AuthService, public navService: NavService) {}

  public ngOnInit(){
    this.navService.verificaQuantidadeNotificacoes();
  }
}
